import { render, staticRenderFns } from "./GatewayCustomers.vue?vue&type=template&id=385dbb63&"
import script from "./GatewayCustomers.vue?vue&type=script&lang=js&"
export * from "./GatewayCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports